export const styles = {
  root: {
    padding: '40px',
    paddingTop: '20px',
  },
};
